export var BiUpdateType;
(function(BiUpdateType) {
    BiUpdateType[BiUpdateType["ADD"] = 0] = "ADD";
    BiUpdateType[BiUpdateType["CHANGE"] = 1] = "CHANGE";
})(BiUpdateType || (BiUpdateType = {}));
export var ReferralType;
(function(ReferralType) {
    ReferralType["FAVOURITE"] = "favourite";
    ReferralType["ADD_TO_PRIVATE_COLLECTION"] = "add_to_private_collection";
    ReferralType["ADD_TO_GROUP"] = "add_to_group";
    ReferralType["WATCH"] = "watch";
    ReferralType["EDIT_DEVIATION"] = "edit_deviation";
    ReferralType["DELETE_DEVIATION"] = "delete_deviation";
    ReferralType["MATURE"] = "mature";
    ReferralType["ANTISOCIAL"] = "members_only_art_viewing";
    ReferralType["POLL_VOTE"] = "poll_vote";
    ReferralType["GIVE"] = "give";
    ReferralType["DONATE_POINTS"] = "donate_points";
    ReferralType["SUBMIT"] = "submit";
    ReferralType["COMMENT_ACTION"] = "comment_action";
    ReferralType["REPORT"] = "report";
    ReferralType["NOTE"] = "note";
    ReferralType["CHAT"] = "chat";
    ReferralType["COMMENT"] = "comment";
    ReferralType["EMPTY_COMMENT"] = "empty_comment";
    ReferralType["HEADER"] = "header";
    ReferralType["LOGIN"] = "login";
    ReferralType["ANON_DOWNLOAD"] = "anon_download";
    ReferralType["BACKGROUND_MODAL"] = "background_modal";
    ReferralType["USER_STATS"] = "user_stats";
    ReferralType["CUSTOM_BOX"] = "custom_box";
    ReferralType["USER_SYMBOL_POPUP"] = "user_symbol_popup";
    ReferralType["USER_SYMBOL_POPUP_EXTEND"] = "user_symbol_popup_extend";
    ReferralType["SISU_FUNNEL_BANNER"] = "sisu_funnel_banner";
    ReferralType["SISU_FUNNEL_NEXT_DEVIATION"] = "next_deviation";
    ReferralType["BADGE_GET_FRAGMENTS"] = "badge_get_fragments";
    ReferralType["ANON_NETWORKBAR"] = "anon_networkbar";
    ReferralType["CREATE_COMMISSION"] = "create_commission";
    ReferralType["CREATE_GALLERY"] = "create_gallery";
    ReferralType["RECENT_VISITORS"] = "recent_visitors";
    ReferralType["JOIN_GROUP"] = "join_group";
    ReferralType["BILLING_PAYMENTS"] = "billing_payments";
    ReferralType["CORE_BILLING_PAYMENTS"] = "core_billing_payments";
    ReferralType["PURCHASE_HISTORY_BILLING_PAYMENTS"] = "purchase_history_billing_payments";
    ReferralType["UPGRADE_CORE_BILLING_PAYMENTS"] = "upgrade_core_billing_payments";
    ReferralType["ART_THEFT_DETECTION"] = "art_theft_detection";
    ReferralType["MEMBER_SUBSCRIBE"] = "member_subscribe";
    ReferralType["COMPARE_TIER_UNIQUE"] = "compare_tier_unique";
    ReferralType["COMPARE_CONTENT_PAGE"] = "compare_content_page";
    ReferralType["HOME_WIDGET"] = "home_widget";
    ReferralType["ACTION_BAR"] = "action_bar";
    ReferralType["PROMOTION_HOME"] = "promotion_home";
    ReferralType["PROMOTION_DYW"] = "promotion_dyw";
    ReferralType["SIDE_BAR_TIER_UNIQUE"] = "side_bar_tier_unique";
    ReferralType["SIDE_BAR_CONTENT_PAGE"] = "side_bar_content_page";
    ReferralType["SITE_FOOTER"] = "site_footer";
    ReferralType["SUBSCRIPTIONS"] = "subscriptions";
    ReferralType["SUBSCRIPTIONS_GO_LIVE"] = "subscriptions_go_live";
    ReferralType["SUBSCRIPTIONS_TIER_CREATION"] = "subscriptions_tier_creation";
    ReferralType["SUBSCRIPTIONS_TIER_DRAFT"] = "subscriptions_tier_draft";
    ReferralType["TIER_UNIQUE"] = "tier_unique";
    ReferralType["TIER_MODAL"] = "tier_modal";
    ReferralType["CONTENT_PAGE"] = "content_page";
    ReferralType["SUBSCRIPTIONS_WIDGET"] = "subscriptions_widget";
    ReferralType["LOCKED_CONTENT"] = "locked_content";
    ReferralType["TIER_CARD"] = "tier_card";
    ReferralType["DAPROTECT_OFF"] = "daprotect_off";
    ReferralType["DAPROTECT_TEMP"] = "daprotect_temp";
    ReferralType["PAYWALL_WATCHERS_ONLY"] = "paywall_watchers_only";
    ReferralType["PAYWALL_PG"] = "paywall_pg";
    ReferralType["PAYWALL_PCP"] = "paywall_pcp";
    ReferralType["PROMOTION_BANNER_USERMENU"] = "promotion_banner_usermenu";
    ReferralType["PROMOTION_BANNER_CONTENT_PAGE"] = "promotion_banner_content_page";
    ReferralType["PROMOTION_BANNER_HOME"] = "promotion_banner_home";
    ReferralType["PROMOTION_BANNER_PROFILE"] = "promotion_banner_profile";
    ReferralType["SIDEBAR_PROMOTION"] = "sidebar_promotion";
    ReferralType["ART_STAGE_PROMOTION"] = "art_stage_promotion";
    ReferralType["PROFILE_COVER_PROMOTION"] = "profile_cover_promotion";
    ReferralType["PROFILE_SUBSCRIPTIONS"] = "profile_subscriptions";
    ReferralType["PRIVATE_COLLECTIONS_SECTION"] = "profile_private_collections_section";
    ReferralType["PRIVATE_COLLECTIONS_POPUP"] = "private_collections_poup";
    ReferralType["SUBSCRIPTIONS_CORE_EXPIRED"] = "subscriptions_core_expired";
    ReferralType["DYW_BIRTHDAY"] = "dyw_birthday";
    ReferralType["HOMEPAGE_PROMOTION"] = "homepage_promotion";
    ReferralType["PROTECT_LEFT"] = "protect_left";
    ReferralType["PROTECT_TOP_BANNER"] = "protect_top_banner";
    ReferralType["PROTECT_LIMIT_SPACE"] = "protect_limit_space";
    ReferralType["SHARE_TO_POST"] = "share_to_post";
    ReferralType["AWARD_BADGE"] = "award_badge";
    ReferralType["SHOP_PREMIUM_GALLERIES"] = "shop_premium_galleries";
    ReferralType["SHOP_PREMIUM_DOWNLOADS"] = "shop_premium_downloads";
    ReferralType["SHOP_ADOPTABLES"] = "shop_adoptables";
    ReferralType["WIDGET_PAYWALL_OVERLAY"] = "widget_paywall_overlay";
    ReferralType["WIDGET_PAYWALL_PREVIEW"] = "widget_paywall_preview";
    ReferralType["DEVIATION_WIDGET_PAYWALL_OVERLAY"] = "deviation_widget_paywall_overlay";
    ReferralType["DEVIATION_WIDGET_PAYWALL_PREVIEW"] = "deviation_widget_paywall_preview";
    ReferralType["LLAMAFARM_WIDGET_PAYWALL_OVERLAY"] = "llamafarm_widget_paywall_overlay";
    ReferralType["LLAMAFARM_WIDGET_PAYWALL_PREVIEW"] = "llamafarm_widget_paywall_preview";
    ReferralType["BADGES_SPOTLIGHT_PAYWALL_OVERLAY"] = "badges_spotlight_paywall_overlay";
    ReferralType["BADGES_SPOTLIGHT_PAYWALL_PREVIEW"] = "badges_spotlight_paywall_preview";
    ReferralType["PROFILE_SKINS"] = "profile_skins";
    ReferralType["PROFILE_SUBNAV"] = "profile_subnav";
    ReferralType["CONTACT_US"] = "contact_us";
    ReferralType["DREAMUP_LEFT"] = "dreamup_left";
    ReferralType["DREAMUP_LEFT_NO_PROMPTS"] = "dreamup_left_no_prompts";
    ReferralType["DREAMUP_TOP_CREATE"] = "dreamup_top_create";
    ReferralType["DREAMUP_CORE_UPSELL"] = "dreamup_core_upsell";
    ReferralType["NSFG"] = "nsfg";
    ReferralType["ANON_JOIN_NOTIFICATION"] = "anon_join_notification";
    ReferralType["SELL_DEVIATION"] = "sell_deviation";
    ReferralType["TOPIC_WATCH_CHANGE"] = "topic_watch_change";
    ReferralType["WATCH_BIRTHDAY"] = "watch_birthday";
    ReferralType["BADGES_LOG_HYPE"] = "badges_log_hype";
    ReferralType["STUDIO_MULTI_SUBMIT"] = "studio_multi_submit";
    ReferralType["STUDIO_MULTI_SUBMIT_TOOLTIP"] = "studio_multi_submit_tooltip";
    ReferralType["STUDIO_BATCH_ACTION"] = "studio_batch_action";
    ReferralType["STUDIO_BATCH_TIER"] = "studio_batch_tier";
    ReferralType["STUDIO_BATCH_SCHEDULE"] = "studio_batch_schedule";
    ReferralType["STUDIO_SIZE_LIMIT_TOOLTIP"] = "studio_size_limit_tooltip";
    ReferralType["SUBMIT_SELL_SECTION"] = "submit_sell_section";
    ReferralType["STUDIO_SCHEDULE"] = "studio_schedule";
    ReferralType["HIDE_PROMPT"] = "hide_prompt";
    ReferralType["CORE_CYCLE_PICKER"] = "core_cycle_picker";
})(ReferralType || (ReferralType = {}));

//# sourceMappingURL=constants.js.map